import React, { Component } from "react";
import classnames from "classnames";
import _ from "i18n";
import { SettingIcon } from "../../Common/Icons";
import { NavLink } from "react-router-dom";

export default class SettingsLink extends Component {
  render() {
    return (
      <div className={"settings-menu"}>
        <div className={"settings-menu-drop-down"}>
          <li>
            <SettingIcon fill="#C7E8FE" size={18} />
            <span>{_("settings")}</span>
          </li>
          <i className={classnames("icon icon-arrow-down")} />
        </div>

        <div className={"settings-list"}>
          <NavLink to={"/authorizations"}>{_("users")}</NavLink>

          <NavLink to={"/associate-dashboards"}>
            {_("manageAssociations")}
          </NavLink>

          <NavLink to={"/annexe-categories"}>{_("manageCategories")}</NavLink>

          <NavLink to={"/indicators-explanation"}>
            {_("manageExplanation")}
          </NavLink>

          <NavLink to={"/extra-slides"}>{_("extra-slides")}</NavLink>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Menu/SubMenu/SettingsLink.js